import React from 'react';
import ClickLink from '../ClickLink';

function handleClickOpenChat() {
  const chatbotButton = document?.querySelector('#hi-custom-widget');
  if (chatbotButton) {
    chatbotButton.click();
  }
}

export const faqProvider = [
  {
    id: 1,
    title: 'Como entrar em contato com o setor comercial?',
    contentString:
      'Na página inicial você deve clicar em “Atendimento Comercial” para obter as informações de contato.',
    content: (
      <>
        Na página inicial você deve clicar em “Atendimento Comercial” para obter
        as informações de contato.
      </>
    ),
  },
  {
    id: 2,
    title: 'Como solicitar a rescisão de contrato?',
    contentString:
      'Para encaminhar o pedido de rescisão, o responsável legal pelo contrato deve entrar em contato com a Central de Atendimento Ultragaz, nos números: 4003-1616 (regiões metropolitanas) ou 0800-886-1616 (demais regiões). Nessa ligação, será aberto o protocolo da solicitação.',
    content: (
      <>
        <p>
          Para encaminhar o pedido de rescisão, o responsável legal pelo
          contrato deve entrar em contato com a Central de Atendimento Ultragaz,
          nos números: 4003-1616 (regiões metropolitanas) ou 0800-886-1616
          (demais regiões). Nessa ligação, será aberto o protocolo da
          solicitação.
        </p>
        <p>
          O atendimento comercial dará sequência a esse processo. No prazo
          máximo de 5 dias úteis, o consultor comercial dará um retorno, fazendo
          uma análise detalhada do contrato vigente para chegar à melhor solução
          possível. O consultor fará, então, novo contato, orientando sobre como
          será concluído o processo de rescisão.
        </p>
      </>
    ),
  },
  {
    id: 3,
    title: 'Como obter a segunda via do meu contrato?',
    contentString:
      'Para consultar seus contratos e/ou adendos, basta clicar em "perfil", no canto superior direito. Você consegue realizar o download do documento, ou enviá-lo por e-mail. Ao solicitar a documentação, será registrado um protocolo e o setor comercial retornará o contato no prazo máximo de até 5 dias úteis através do seu e-mail cadastrado e/ou telefone.',
    content: (
      <>
        <span>
          Para consultar seus contratos e/ou adendos, basta clicar em “perfil”,
          no canto superior direito. Você consegue realizar o download do
          documento, ou enviá-lo por e-mail. Ao solicitar a documentação, será
          registrado um protocolo e o setor comercial retornará o contato no
          prazo máximo de até
        </span>

        <b> 5 dias úteis através </b>
        <span>do seu</span>
        <b> e-mail cadastrado e/ou telefone.</b>
      </>
    ),
  },
  {
    id: 4,
    title: 'Realizei uma solicitação de abastecimento. Como devo proceder?',
    contentString:
      'Nossa equipe vai analisar o seu pedido e, caso tenha disponibilidade, o abastecimento será confirmado imediatamente. Caso isso não seja possível, entraremos com contato por telefone ou e-mail, sugerindo uma nova data.',
    content: (
      <>
        Nossa equipe vai analisar o seu pedido e, caso tenha disponibilidade, o
        abastecimento será confirmado imediatamente. Caso isso não seja
        possível, entraremos com contato por telefone ou e-mail, sugerindo uma
        nova data.
      </>
    ),
  },
  {
    id: 5,
    title:
      'Realizei uma solicitação de abastecimento. Como posso confirmar o dia em que o serviço foi agendado?',
    contentString:
      'Você pode acompanhar seu pedido no portal do cliente, consultando o histórico de solicitações de abastecimento no campo “Data de atendimento”. Caso essa informação não esteja disponível, fale conosco via canais de atendimento. Nossa equipe de logística fará uma nova verificação e retornaremos a você por telefone ou e-mail.',
    content: (
      <>
        Você pode acompanhar seu pedido no portal do cliente, consultando o
        histórico de solicitações de abastecimento no campo
        <b> “Data de atendimento”. </b>
        Caso essa informação não esteja disponível, fale conosco via canais de
        atendimento. Nossa equipe de logística fará uma nova verificação e
        retornaremos a você por telefone ou e-mail.
      </>
    ),
  },
  {
    id: 6,
    title:
      'Meu abastecimento possui rota de 5 dias de viagem. Quando receberei o meu pedido?',
    contentString:
      'Quando sua rota é de viagem, será necessário considerar que seu abastecimento acontecerá dentro da quantidade de dias previstos de viagem. Por exemplo, sendo a rota de 5 dias, você receberá dentro desse período estabelecido de rota de viagem.',
    content: (
      <>
        Quando sua rota é de viagem, será necessário considerar que seu
        abastecimento acontecerá dentro da quantidade de dias previstos de
        viagem. Por exemplo, sendo a rota de 5 dias, você receberá dentro desse
        período estabelecido de rota de viagem.
      </>
    ),
  },
  {
    id: 7,
    title:
      'Não estou conseguindo solicitar abastecimento pelo portal. O que devo fazer?',
    contentString:
      'Em caso de instabilidade com o portal, você precisará solicitar através da Central de Atendimento Ultragaz, nos números: 4003-1616 (regiões metropolitanas) ou 0800-886-1616 (demais regiões). Se a sua forma de abastecimento é do tipo “Agendado”, fique tranquilo, que a Ultragaz está acompanhando o seu consumo de perto e garantimos que você não ficará sem gás. Agora, se a sua forma de abastecimento é do tipo “Pedido”, a gestão do seu estoque de gás ainda não está conosco. Por isso, para garantir mais comodidade ao seu dia a dia altere o seu modelo de abastecimento para o tipo “Agendado”.',
    content: (
      <>
        <span>
          <span>
            Em caso de instabilidade com o portal, você precisará solicitar
            através da Central de Atendimento Ultragaz, nos números: 4003-1616
            (regiões metropolitanas) ou 0800-886-1616 (demais regiões). Se a sua
            forma de abastecimento é do tipo
          </span>
          <b> “Agendado” </b>
          <span>
            , fique tranquilo, que a Ultragaz está acompanhando o seu consumo de
            perto e garantimos que você não ficará sem gás. Agora, se a sua
            forma de abastecimento é do tipo
          </span>
          <b> “Pedido” </b>
          <span>
            , a gestão do estoque de gás ainda não está conosco. Por isso, para
            garantir mais comodidade ao seu dia a dia altere o seu modelo de
            abastecimento para o tipo
          </span>
          <b> “Agendado” </b>
          <span>.</span>
        </span>
      </>
    ),
  },
  {
    id: 8,
    title:
      'Qual a diferença entre a forma de abastecimento “Pedido” e “Agendado”?',
    contentString:
      'Quando você está na modalidade “Pedido”, quem acompanha o seu estoque é você e será necessário solicitar abastecimento toda vez que avaliar que seu estoque não atenderá sua demanda. Sugerimos que as solicitações sejam feitas com estoque em torno de 40%, para termos tempo hábil de abastecê-lo. Você poderá solicitar abastecimento através do Portal Minha Ultragaz, no menu “Abastecimento”.',
    content: (
      <span>
        <span>Quando você está na modalidade</span>
        <b> “Pedido” </b>
        <span>
          , quem acompanha o seu estoque é você e será necessário solicitar
          abastecimento toda vez que avaliar que seu estoque não atenderá sua
          demanda. Sugerimos que as solicitações sejam feitas com estoque em
          torno de 40%, para termos tempo hábil de abastecê-lo. Você poderá
          solicitar abastecimento através do Portal Minha Ultragaz, no menu
        </span>
        <b> “Abastecimento”. </b>
        <span>
          <span>Quando você é da modalidade</span>
          <b> “Agendado” </b>
          <span>
            , a Ultragaz acompanha o seu consumo de perto e não será necessário
            solicitar abastecimento. Ainda assim, quando identificar uma
            condição atípica, em que prevê um aumento de consumo no próximo
            período, você poderá seguir com a solicitação através do Portal
            Minha Ultragaz, no menu
          </span>
          <b> “Abastecimento”.</b>
        </span>
      </span>
    ),
  },
  {
    id: 9,
    title: 'Como posso solicitar a alteração da forma que serei abastecido?',
    contentString:
      'Você precisará solicitar através da Central de Atendimento Ultragaz nos números: 4003-1616 (regiões metropolitanas) ou 0800-886-1616 (demais regiões). Ou ainda, acessar a Ully (clique aqui), selecione “Outros assuntos” e em seguida você será direcionado para um chat para falar com um de nossos operadores. Sua solicitação será analisada por nossa equipe de programação, que, com base em seu histórico de consumo, vai sugerir a você a opção mais adequada.',
    content: (
      <>
        <span>
          <span>
            Você precisará solicitar através da Central de Atendimento Ultragaz
            nos números: 4003-1616 (regiões metropolitanas) ou 0800-886-1616
            (demais regiões). Ou ainda, acessar a Ully
          </span>
          <button type="button" onClick={() => handleClickOpenChat()}>
            (clique aqui)
          </button>
          <span>, selecione</span>
          <b> “Outros assuntos” </b>
          <span>
            e em seguida você será direcionado para um chat para falar com um de
            nossos operadores. Sua solicitação será analisada por nossa equipe
            de programação, que, com base em seu histórico de consumo, vai
            sugerir a você a opção mais adequada.
          </span>
        </span>
      </>
    ),
  },
  {
    id: 10,
    title: 'Como posso obter meu histórico do meu consumo?',
    contentString:
      'Você pode visualizá-lo na tela inicial do portal. Ainda é possível fazer o download do seu histórico de consumo, clicando em “Exportar xls”.',
    content: (
      <>
        <span>
          Você pode visualizá-lo na tela inicial do portal. Ainda é possível
          fazer o download do seu histórico de consumo, clicando em
        </span>
        <b> “Exportar xls”.</b>
      </>
    ),
  },
  {
    id: 11,
    title:
      'Quero solicitar um abastecimento por depósito antecipado. O que devo fazer?',
    contentString:
      'Você precisa entrar em contato com a Central de Atendimento Ultragaz, nos números: 4003-1616 (regiões metropolitanas) ou 0800-886-1616 (demais regiões). Nossa equipe de atendimento te informará os dados bancários para realização do depósito. A equipe financeira terá 2 dias úteis para identificar o valor em conta. Depois dessa confirmação, nossa equipe de logística vai agendar seu abastecimento conforme a data de visita à sua região. Essa data será informada por e-mail ou telefone.',
    content: (
      <>
        Você precisa entrar em contato com a Central de Atendimento Ultragaz,
        nos números: 4003-1616 (regiões metropolitanas) ou 0800-886-1616 (demais
        regiões). Nossa equipe de atendimento te informará os dados bancários
        para realização do depósito. A equipe financeira terá 2 dias úteis para
        identificar o valor em conta. Depois dessa confirmação, nossa equipe de
        logística vai agendar seu abastecimento conforme a data de visita à sua
        região. Essa data será informada por e-mail ou telefone.
      </>
    ),
  },
  {
    id: 12,
    title: 'Quero antecipar o dia do meu abastecimento. O que devo fazer?',
    contentString:
      'Você poderá solicitar a antecipação de seu abastecimento através do Portal Minha Ultragaz, no menu “Abastecimento”, realizando a abertura de um “Novo Pedido”.',
    content: (
      <>
        <span>
          Você poderá solicitar a antecipação de seu abastecimento através do
          Portal Minha Ultragaz, no menu
        </span>
        <b> “Abastecimento” </b>
        <span>, realizando a abertura de um </span>
        <b> “Novo Pedido”.</b>
      </>
    ),
  },
  {
    id: 13,
    title: 'Meu pedido não foi entregue na data agendada. E agora?',
    contentString:
      'Sendo abastecido na modalidade “Agendado” você será notificado toda vez que houver uma reprogramação de seu abastecimento. Quando estiver na modalidade “Pedido”, será necessário entrar em contato com a Central de Atendimento Ultragaz, nos números: 4003-1616 (regiões metropolitanas) ou 0800-886-1616 (demais regiões). Ainda é possível falar com a Ully (clique aqui), selecione “Outros assuntos” e em seguida você será direcionado para um chat para falar com um de nossos operadores. Nossa equipe responsável irá esclarecer o que aconteceu e informará uma nova data.',
    content: (
      <>
        <span>
          <span>Sendo abastecido na modalidade</span>
          <b> “Agendado” </b>
          <span>
            você será notificado toda vez que houver uma reprogramação de seu
            abastecimento. Quando estiver na modalidade
          </span>
          <b> “Pedido” </b>
          <span>
            , será necessário entrar em contato com a Central de Atendimento
            Ultragaz, nos números: 4003-1616 (regiões metropolitanas) ou
            0800-886-1616 (demais regiões). Ainda é possível falar com a Ully
          </span>
          <button type="button" onClick={() => handleClickOpenChat()}>
            (clique aqui)
          </button>
          <span>, selecione</span>
          <b> “Outros assuntos” </b>
          <span>
            e em seguida você será direcionado para um chat para falar com um de
            nossos operadores. Nossa equipe responsável irá esclarecer o que
            aconteceu e informará uma nova data.
          </span>
        </span>
      </>
    ),
  },
  {
    id: 14,
    title: 'Como solicitar a instalação de mais vasilhames?',
    contentString: `Você pode instalar novos vasilhames em sua central para atender melhor às suas necessidades de GLP. Primeiro, você entra em contato com o seu consultor comercial. Os dados de contato do time comercial podem ser encontrados no botão “Atendimento Comercial”, localizado na tela inicial do portal. Ele enviará ao local uma equipe técnica da Ultragaz, que vai calcular a quantidade adequada de vasilhames, de acordo com o volume de consumo. Em seguida, será feito um projeto para a expandir a capacidade de sua central, que pode ter o tamanho da sua necessidade. As negociações sobre prazo e custo da expansão vão ser conduzidas pelo seu consultor comercial.`,
    content: (
      <>
        <span>
          Você pode instalar novos vasilhames em sua central para atender melhor
          às suas necessidades de GLP. Primeiro, você entra em contato com o seu
          consultor comercial. Os dados de contato do time comercial podem ser
          encontrados no botão
        </span>
        <b> “Atendimento Comercial” </b>
        <span>
          , localizado na tela inicial do portal. Ele enviará ao local uma
          equipe técnica da Ultragaz, que vai calcular a quantidade adequada de
          vasilhames, de acordo com o volume de consumo. Em seguida, será feito
          um projeto para a expandir a capacidade de sua central, que pode ter o
          tamanho da sua necessidade. As negociações sobre prazo e custo da
          expansão vão ser conduzidas pelo seu consultor comercial.
        </span>
      </>
    ),
  },
  {
    id: 15,
    title: 'Como solicitar a retirada de vasilhames?',
    contentString: `Você precisa solicitar ao seu consultor comercial a rescisão do contrato. Ele vai encaminhar o processo com as áreas responsáveis da Ultragaz. Em seguida, a área técnica vai entrar em contato com você para agendar a retirada dos vasilhames. Para falar com seu consultor comercial, basta acessar a tela inicial, no botão “Atendimento Comercial”. `,
    content: (
      <>
        <span>
          Você precisa solicitar ao seu consultor comercial a rescisão do
          contrato. Ele vai encaminhar o processo com as áreas responsáveis da
          Ultragaz. Em seguida, a área técnica vai entrar em contato com você
          para agendar a retirada dos vasilhames. Para falar com seu consultor
          comercial, basta acessar a tela inicial, no botão
        </span>
        <b> “Atendimento Comercial”.</b>
      </>
    ),
  },
  {
    id: 16,
    title:
      'Vou fazer uma obra e será preciso modificar minha central. O que devo fazer?',
    contentString: `É muito simples! Basta você abrir uma solicitação de manutenção através do portal. Clique no menu “Manutenção” e em seguida em “Solicitar manutenção”. Será solicitada uma visita técnica para avaliar as alterações que serão feitas, analisando se elas vão exigir modificações em sua central. Toda essa avaliação terá por base os requisitos de segurança e o pleno atendimento de suas necessidades. Esse estudo prévio vai apontar, também se vai ser preciso alguma intervenção da Ultragaz antes que as obras no local sejam iniciadas. Se você tiver dúvidas, fale com a Ully, nossa assistente virtual, pelo WhatsApp 11 93305-8481. `,
    content: (
      <>
        <span>
          <span>
            É muito simples! Basta você abrir uma solicitação de manutenção
            através do portal. Clique no menu
          </span>
          <b> “Manutenção” </b>
          <span>e em seguida em</span>
          <b> “Solicitar manutenção” </b>
          <span>
            . Será solicitada uma visita técnica para avaliar as alterações que
            serão feitas, analisando se elas vão exigir modificações em sua
            central. Toda essa avaliação terá por base os requisitos de
            segurança e o pleno atendimento de suas necessidades. Esse estudo
            prévio vai apontar, também se vai ser preciso alguma intervenção da
            Ultragaz antes que as obras no local sejam iniciadas. Se você tiver
            dúvidas, fale com a
          </span>
          <button type="button" onClick={() => handleClickOpenChat()}>
            Ully,
          </button>
          <span>nossa assistente virtual, pelo WhatsApp 11 93305-8481.</span>
        </span>
      </>
    ),
  },
  {
    id: 17,
    title: 'Preciso de uma documentação técnica. Como devo solicitá-la?',
    contentString: `É muito simples e rápido! Basta acessar o nosso Portal. No menu lateral
      esquerdo, está a opção “Documentos Técnicos”. Clique aqui e confira!`,
    content: (
      <>
        É muito simples e rápido! Basta acessar o nosso Portal. No menu lateral
        esquerdo, está a opção “Documentos Técnicos”.
        <>
          <ClickLink text="Clique aqui" link="documentacao" />
        </>
        e confira!
      </>
    ),
  },
  {
    id: 18,
    title:
      'Estou sentindo cheiro de gás próximo à minha central. O que fazer? ',
    contentString: `Você pode pedir ajuda em nosso Portal. No menu lateral esquerdo, você clica em “Manutenção > Solicitar Manutenção” e depois seleciona a opção “Solicitar”. Uma das alternativas é a pergunta: “Está sentindo cheio de gás?”. Clique em “sim”, preencha as informações solicitadas e aguarde o contato do nosso técnico. É simples e rápido!`,
    content: (
      <>
        {`Você pode pedir ajuda em nosso Portal. No menu lateral esquerdo, você clica em “Manutenção > Solicitar Manutenção” e depois seleciona a opção “Solicitar”. Uma das alternativas é a pergunta: “Está sentindo cheio de gás?”. Clique em “sim”, preencha as informações solicitadas e aguarde o contato do nosso técnico. É simples e rápido!`}
      </>
    ),
  },
  {
    id: 19,
    title: 'A pressão do gás está alta/baixa. Como proceder?',
    contentString: `Para a sua comodidade, este serviço está disponível em nosso Portal. No menu lateral esquerdo, você clica em “Manutenção > Solicitar Manutenção”, e responde às perguntas que vão levar à abertura de um chamado com motivo “Falha no Fornecimento”. É fácil e rápido!`,
    content: (
      <>
        {`Para a sua comodidade, este serviço está disponível em nosso Portal. No menu lateral esquerdo, você clica em “Manutenção > Solicitar Manutenção”, e responde às perguntas que vão levar à abertura de um chamado com motivo “Falha no Fornecimento”. É fácil e rápido!`}
      </>
    ),
  },
  {
    id: 20,
    title: 'Preciso fazer um teste de estanqueidade. Como proceder?',
    contentString: `É muito simples! Basta você abrir uma solicitação de manutenção através do portal. Clique no menu “Manutenção” e em seguida em “Solicitar manutenção”. Será solicitada uma visita técnica para avaliar.`,
    content: (
      <>
        <span>
          <span>
            É muito simples! Basta você abrir uma solicitação de manutenção
            através do portal. Clique no menu
          </span>
          <b> “Manutenção” </b>
          <span>e em seguida em</span>
          <b> “Solicitar manutenção” </b>
          <span>. Será solicitada uma visita técnica para avaliar.</span>
        </span>
      </>
    ),
  },
  {
    id: 21,
    title: 'Quem é Atento? Ela tem relação com a Ultragaz?',
    contentString: `A Atento, empresa especializada em serviços de relacionamento com
    cliente, é parceira da Ultragaz na realização do serviço de cobrança.
    Você poderá contar com eles para negociar títulos vencidos.

    Atento
    Telefone: (11) 3250-2894 ou 0800 605 6577
    WhatsApp: (11) 93298-8845 / (11) 94064-0689
    Email: contato.ultragaz@atento.com`,
    content: (
      <>
        <p>
          A Atento, empresa especializada em serviços de relacionamento com
          cliente, é parceira da Ultragaz na realização do serviço de cobrança.
          Você poderá contar com eles para negociar títulos vencidos.
        </p>
        <div className="span-wrap">
          <span>Atento</span>
          <span>Telefone: (11) 3250-2894 ou 0800 605 6577</span>
          <span>WhatsApp: (11) 93298-8845 / (11) 94064-0689</span>
          <span>Email: contato.ultragaz@atento.com</span>
        </div>
      </>
    ),
  },
];
